module.exports = __webpack_public_path__ + "img/532m0.d22dbccc.svg";